import { Calendar7 as r } from "./calendar-7.js";
import { CheckmarkSmall as o } from "./checkmark-small.js";
import { CheckmarkCircleFill as m } from "./checkmark-circle-fill.js";
import { Clock as i } from "./clock.js";
import { Cross as t } from "./cross.js";
import { CrossCircleFill as p } from "./cross-circle-fill.js";
import { Location as f } from "./location.js";
import { Menu as l } from "./menu.js";
import { SearchList as e } from "./search-list.js";
import { Search as a } from "./search.js";
import { Sliders2 as n } from "./sliders-2.js";
import { Star as s } from "./star.js";
import { StarFill as c } from "./star-fill.js";
import { Info as d } from "./info.js";
import { InfoFilled as C } from "./info-filled.js";
import { Plus as u } from "./plus.js";
import { PlayCircle as S } from "./play-circle.js";
import { ThumbUp as F } from "./thumb-up.js";
import { ThumbDown as h } from "./thumb-down.js";
import { Tooltip as k } from "./tooltip.js";
import { Collection as g } from "./collection.js";
import { Collections as P } from "./collections.js";
import { Warning as M } from "./warning.js";
import { WarningFilled as y } from "./warning-filled.js";
import { WarningDiamondFilled as B } from "./warning-diamond-filled.js";
import { PlusSmall as T } from "./plus-small.js";
import { PlusMedium as b } from "./plus-medium.js";
import { MinusSmall as H } from "./minus-small.js";
import { MinusCircle as W } from "./minus-circle.js";
import { MinusCircleFilled as w } from "./minus-circle-filled.js";
import { PlusSquare as E } from "./plus-square.js";
import { PlusSquareFilled as I } from "./plus-square-filled.js";
import { MinusSquare as q } from "./minus-square.js";
import { MinusSquareFilled as L } from "./minus-square-filled.js";
import { PlusMultiple as A } from "./plus-multiple.js";
import { MinusMultiple as D } from "./minus-multiple.js";
import { CheckmarkCircleSmall as N } from "./checkmark-circle-small.js";
import { WarningCircleFill as O } from "./warning-circle-fill.js";
import { WarningCircle as z } from "./warning-circle.js";
import { Blocked as G } from "./blocked.js";
import { PlayCircleFill as Z } from "./play-circle-fill.js";
import { SearchSmall as v } from "./search-small.js";
import { ZoomIn as x } from "./zoom-in.js";
import { ZoomOut as Q } from "./zoom-out.js";
import { Sliders as U } from "./sliders.js";
import { Show as V } from "./show.js";
import { Hide as j } from "./hide.js";
import { Filter as J } from "./filter.js";
import { Pin as K } from "./pin.js";
import { Sleep as R } from "./sleep.js";
import { Timer as X } from "./timer.js";
import { Hourglass as Y } from "./hourglass.js";
import { Settings as _ } from "./settings.js";
import { Edit as $ } from "./edit.js";
import { Edit2 as rr } from "./edit-2.js";
import { Edited as or } from "./edited.js";
import { Mail as mr } from "./mail.js";
import { Message as ir } from "./message.js";
import { Bucket as tr } from "./bucket.js";
import { Copy as pr } from "./copy.js";
import { Tag as fr } from "./tag.js";
import { Grab as lr } from "./grab.js";
import { Person as er } from "./person.js";
import { PersonCircle as ar } from "./person-circle.js";
import { OptionsHorizontal as nr } from "./options-horizontal.js";
import { Code1 as sr } from "./code-1.js";
import { Code2 as cr } from "./code-2.js";
import { Code3 as dr } from "./code-3.js";
import { Heart as Cr } from "./heart.js";
import { HeartFill as ur } from "./heart-fill.js";
import { Save as Sr } from "./save.js";
import { Chain1 as Fr } from "./chain-1.js";
import { Chain2 as hr } from "./chain-2.js";
import { Table as kr } from "./table.js";
import { Stop as gr } from "./stop.js";
import { Play as Pr } from "./play.js";
import { LetterI as Mr } from "./letter-i.js";
import { Share2 as yr } from "./share-2.js";
import { Breadcrumb as Br } from "./breadcrumb.js";
import { Fingerprint as Tr } from "./fingerprint.js";
import { Battery3 as br } from "./battery-3.js";
import { Battery2 as Hr } from "./battery-2.js";
import { Battery1 as Wr } from "./battery-1.js";
import { BatteryEmpty as wr } from "./battery-empty.js";
import { Sound as Er } from "./sound.js";
import { Wireless as Ir } from "./wireless.js";
import { Touch as qr } from "./touch.js";
import { LineHeight as Lr } from "./line-height.js";
import { Stack as Ar } from "./stack.js";
import { Bin as Dr } from "./bin.js";
import { Notification as Nr } from "./notification.js";
import { CrossCircle as Or } from "./cross-circle.js";
import { CheckmarkCircle as zr } from "./checkmark-circle.js";
import { CheckmarkSquare as Gr } from "./checkmark-square.js";
import { CheckmarkSquareFilled as Zr } from "./checkmark-square-filled.js";
import { CrossSmall as vr } from "./cross-small.js";
import { Accessibility as xr } from "./accessibility.js";
import { AccessibilityFilled as Qr } from "./accessibility-filled.js";
import { AccessibilityPersonFilled as Ur } from "./accessibility-person-filled.js";
import { Apps as Vr } from "./apps.js";
import { AppsFilled as jr } from "./apps-filled.js";
import { BinFilled as Jr } from "./bin-filled.js";
import { Bluetooth as Kr } from "./bluetooth.js";
import { Calendar as Rr } from "./calendar.js";
import { CellularFilled as Xr } from "./cellular-filled.js";
import { Checkmark as Yr } from "./checkmark.js";
import { CheckmarkCircleSmallFilled as _r } from "./checkmark-circle-small-filled.js";
import { CrossCircleFillSmall as $r } from "./cross-circle-fill-small.js";
import { CrossCircleSmall as ro } from "./cross-circle-small.js";
import { Edit1 as oo } from "./edit-1.js";
import { Ethernet as mo } from "./ethernet.js";
import { EthernetFilled as io } from "./ethernet-filled.js";
import { FaceId as to } from "./face-id.js";
import { Freeze as po } from "./freeze.js";
import { Grid as fo } from "./grid.js";
import { Information as lo } from "./information.js";
import { Location2 as eo } from "./location-2.js";
import { Location2Filled as ao } from "./location-2-filled.js";
import { Minus as no } from "./minus.js";
import { Network as so } from "./network.js";
import { NetworkFilled as co } from "./network-filled.js";
import { OptionsVerical as Co } from "./options-verical.js";
import { PlusCircle as uo } from "./plus-circle.js";
import { PlusCircleFilled as So } from "./plus-circle-filled.js";
import { Power as Fo } from "./power.js";
import { QrCode as ho } from "./qr-code.js";
import { SettingsFilled as ko } from "./settings-filled.js";
import { Sliders1 as go } from "./sliders-1.js";
import { Software as Po } from "./software.js";
import { SoftwareFilled as Mo } from "./software-filled.js";
import { StarHalfFilled as yo } from "./star-half-filled.js";
import { SupportHelp as Bo } from "./support-help.js";
import { Toggle as To } from "./toggle.js";
import { ToggleFilled as bo } from "./toggle-filled.js";
import { TooltipFilled as Ho } from "./tooltip-filled.js";
import { WarningDiamond as Wo } from "./warning-diamond.js";
import { Wifi as wo } from "./wifi.js";
const pt = {
  Calendar7: r,
  CheckmarkSmall: o,
  CheckmarkCircleFill: m,
  Clock: i,
  Cross: t,
  CrossCircleFill: p,
  Location: f,
  Menu: l,
  SearchList: e,
  Search: a,
  Sliders2: n,
  Star: s,
  StarFill: c,
  Info: d,
  InfoFilled: C,
  Plus: u,
  PlayCircle: S,
  ThumbUp: F,
  ThumbDown: h,
  Tooltip: k,
  Collection: g,
  Collections: P,
  Warning: M,
  WarningFilled: y,
  WarningDiamondFilled: B,
  PlusSmall: T,
  PlusMedium: b,
  MinusSmall: H,
  MinusCircle: W,
  MinusCircleFilled: w,
  PlusSquare: E,
  PlusSquareFilled: I,
  MinusSquare: q,
  MinusSquareFilled: L,
  PlusMultiple: A,
  MinusMultiple: D,
  CheckmarkCircleSmall: N,
  WarningCircleFill: O,
  WarningCircle: z,
  Blocked: G,
  PlayCircleFill: Z,
  SearchSmall: v,
  ZoomIn: x,
  ZoomOut: Q,
  Sliders: U,
  Show: V,
  Hide: j,
  Filter: J,
  Pin: K,
  Sleep: R,
  Timer: X,
  Hourglass: Y,
  Settings: _,
  Edit: $,
  Edit2: rr,
  Edited: or,
  Mail: mr,
  Message: ir,
  Bucket: tr,
  Copy: pr,
  Tag: fr,
  Grab: lr,
  Person: er,
  PersonCircle: ar,
  OptionsHorizontal: nr,
  Code1: sr,
  Code2: cr,
  Code3: dr,
  Heart: Cr,
  HeartFill: ur,
  Save: Sr,
  Chain1: Fr,
  Chain2: hr,
  Table: kr,
  Stop: gr,
  Play: Pr,
  LetterI: Mr,
  Share2: yr,
  Breadcrumb: Br,
  Fingerprint: Tr,
  Battery3: br,
  Battery2: Hr,
  Battery1: Wr,
  BatteryEmpty: wr,
  Sound: Er,
  Wireless: Ir,
  Touch: qr,
  LineHeight: Lr,
  Stack: Ar,
  Bin: Dr,
  Notification: Nr,
  CrossCircle: Or,
  CheckmarkCircle: zr,
  CheckmarkSquare: Gr,
  CheckmarkSquareFilled: Zr,
  CrossSmall: vr,
  Accessibility: xr,
  AccessibilityFilled: Qr,
  AccessibilityPersonFilled: Ur,
  Apps: Vr,
  AppsFilled: jr,
  BinFilled: Jr,
  Bluetooth: Kr,
  Calendar: Rr,
  CellularFilled: Xr,
  Checkmark: Yr,
  CheckmarkCircleSmallFilled: _r,
  CrossCircleFillSmall: $r,
  CrossCircleSmall: ro,
  Edit1: oo,
  Ethernet: mo,
  EthernetFilled: io,
  FaceId: to,
  Freeze: po,
  Grid: fo,
  Information: lo,
  Location2: eo,
  Location2Filled: ao,
  Minus: no,
  Network: so,
  NetworkFilled: co,
  OptionsVerical: Co,
  PlusCircle: uo,
  PlusCircleFilled: So,
  Power: Fo,
  QrCode: ho,
  SettingsFilled: ko,
  Sliders1: go,
  Software: Po,
  SoftwareFilled: Mo,
  StarHalfFilled: yo,
  SupportHelp: Bo,
  Toggle: To,
  ToggleFilled: bo,
  TooltipFilled: Ho,
  WarningDiamond: Wo,
  Wifi: wo
};
export {
  pt as Interface
};
